import { ChangeEvent, Dispatch, Fragment, SetStateAction, useState, } from "react"; import Avatar from "@mui/material/Avatar"; import {   Chip, Divider, IconButton, List, ListItem, ListItemIcon, ListItemText, TextField, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { RoadmapDto } from "@lib/ShiOneClient";
import useCreateRoadmap from "shared-ui/src/features/roadmaps-feature/hooks/useCreateRoadmap";
import { initialRoadmapState } from "shared-ui/src/features/roadmaps-feature/utils/roadmapProps";
import { SnackbarState } from "../../../../../../../../shared-ui/src/features/roadmaps-feature/interfaces/SnackbarState";

const SendToDialogRoadmapsView = ({
  roadmaps,
  setSnackbars,
  handleRoadmapClick,
}: {
  roadmaps: RoadmapDto[];
  setSnackbars?: Dispatch<SetStateAction<SnackbarState[]>>;
  handleRoadmapClick: (roadmap: RoadmapDto) => void;
}) => {
  const theme = useTheme();
  const mutation = useCreateRoadmap(setSnackbars);

  const [newRoadmapName, setNewRoadmapName] = useState<string>("");
  const handleChangeNewRoadmap = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setNewRoadmapName(event.target.value);
  };
  const handleSubmitNewRoadmap = () => {
    const newRoadmap = { ...initialRoadmapState, name: newRoadmapName };
    mutation.mutate(newRoadmap as RoadmapDto, {
      onSuccess: (response) => {
        const roadmap = response?.roadmap;
        if (roadmap) {
          handleRoadmapClick(roadmap);
        }
      },
      onError: () => {
        setSnackbars?.((prev: SnackbarState[]) => [
          ...prev, {
            key: new Date().getTime() + Math.random(),
            message: "There was an issue creating the item, please try again later.",
            severity: "error",
          }
        ]);
      },
    });
  };
  return (
    <List>
      {roadmaps?.map((roadmap) => {
        const initiatives = roadmap?.roadmapItems?.filter(
          (roadmapItem) => !roadmapItem.parentRoadmapItemId,
        );
        return (
          <Fragment key={roadmap.id}>
            <ListItem>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                padding={1}
              >
                <Grid item xs display="flex" alignItems="center" gap={2}>
                  <ListItemIcon sx={{ minWidth: "auto" }}>
                    <FactCheckIcon />
                  </ListItemIcon>
                  <ListItemText primary={roadmap.name} />

                  <Chip
                    variant="outlined"
                    avatar={
                      <Avatar sx={{ width: 24, height: 24 }}>
                        <Typography variant="caption" color={theme.palette.common.black}>
                          {initiatives?.length}
                        </Typography>
                      </Avatar>
                    }
                    label={<Typography>Initiatives</Typography>}
                    onClick={() => handleRoadmapClick(roadmap)}
                  >
                  </Chip>
                </Grid>
                <Grid item>
                  <ListItemIcon sx={{ minWidth: "auto" }}>
                    <IconButton onClick={() => handleRoadmapClick(roadmap)}>
                      <ChevronRightIcon />
                    </IconButton>
                  </ListItemIcon>
                </Grid>
              </Grid>
            </ListItem>
            <Divider />
          </Fragment>
        );
      })}
      <ListItem>
        <Grid
          container
          padding={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs>
            <TextField
              fullWidth
              placeholder="Create New Plan"
              variant="outlined"
              size="small"
              value={newRoadmapName}
              onChange={handleChangeNewRoadmap}
            />
          </Grid>
          <Grid item>
            <ListItemIcon sx={{ minWidth: "auto" }}>
              <IconButton
                disabled={!newRoadmapName?.trim()}
                onClick={handleSubmitNewRoadmap}
              >
                <ChevronRightIcon />
              </IconButton>
            </ListItemIcon>
          </Grid>
        </Grid>
      </ListItem>
    </List>
  );
};

export default SendToDialogRoadmapsView;
